export interface ProposalObjectivesAndValueDto {
   categories: {
      id: string,
      name: string,
      subcategories?: {
         id: string,
         name: string,
         items: ProposalObjectiveDto[]
      }[],
      items?: ProposalObjectiveDto[]
   }[]
}

export interface ProposalObjectiveDto {
   id: string,
   objective: string,
   displayOrder: number,
}

const proposalObjectivesAndValues = {
   categories: [
      {
         id: '1',
         name: 'Compliance',
         items: [
            {
               id: '101',
               objective: 'Peace of mind that your Annual Financial Statements and Tax Returns are accurate and filed on time',
               displayOrder: 1,
            },
            { id: '102', objective: 'Meet your tax obligations and pay the least amount of tax as legitimately possible', displayOrder: 2 },
            { id: '103', objective: 'Streamline your business and investment structure for maximum benefit and minimum risk', displayOrder: 3 },
         ],
      },
      {
         id: '2',
         name: 'Advisory',
         subcategories: [
            {
               id: '21',
               name: 'General Advisory',
               items: [
                  { id: '201', objective: 'Identify areas to improve discipline and operate smarter', displayOrder: 1 },
                  { id: '202', objective: 'Improve decision-making, planning and goal setting to achieve your vision', displayOrder: 2 },
                  {
                     id: '203',
                     objective: 'Better understand your financial position and the impact decisions have on your business',
                     displayOrder: 3,
                  },
                  {
                     id: '204',
                     objective: 'Identify opportunities and strategies to improve cashflow, growth, profitability, and business value',
                     displayOrder: 4,
                  },
                  { id: '205', objective: 'Increase mind, time, and financial freedom', displayOrder: 5 },
               ],
            },
            {
               id: '31',
               name: 'Planning & execution',
               items: [
                  { id: '301', objective: 'Unite directors and team in purpose and vision', displayOrder: 1 },
                  {
                     id: '302',
                     objective:
                        'Establish a forum to discuss burning issues, critical challenges, and opportunities with a trusted third-party',
                     displayOrder: 2,
                  },
                  {
                     id: '303',
                     objective: 'Maintain a rolling action plan that supports the implementation of key projects and actions',
                     displayOrder: 3,
                  },
                  { id: '304', objective: 'Free up time by clarifying and delegating roles, key responsibilities, and tasks', displayOrder: 4 },
                  {
                     id: '305',
                     objective: 'Increase accountability to ensure goals and actions are achieved to improve business performance',
                     displayOrder: 5,
                  },
               ],
            },
            {
               id: '41',
               name: 'Risk Management',
               items: [
                  { id: '401', objective: 'Understand how to manage key profit and cashflow drivers', displayOrder: 1 },
                  {
                     id: '402',
                     objective: 'Understand your financial reports and key drivers, enabling better decision-making and outcomes',
                     displayOrder: 2,
                  },
                  { id: '403', objective: 'Identify, record, assess, mitigate, and monitor key risks in your business', displayOrder: 3 },
                  { id: '404', objective: 'Embed ongoing risk management and reporting in your business strategy', displayOrder: 4 },
                  { id: '405', objective: 'Implement strategies to address critical challenges and opportunities', displayOrder: 5 },
               ],
            },
         ],
      },
   ],
} as ProposalObjectivesAndValueDto

export default proposalObjectivesAndValues